import { render } from "./EditRating.vue?vue&type=template&id=59c55cd2"
import script from "./EditRating.vue?vue&type=script&lang=js"
export * from "./EditRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__